import { render, staticRenderFns } from "./BuyerInvites.vue?vue&type=template&id=4971a231"
import script from "./BuyerInvites.vue?vue&type=script&lang=js"
export * from "./BuyerInvites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports